<script setup lang="ts">
import { MenuItem } from "@headlessui/vue";

const { icon = undefined, external = false } = defineProps<{
  icon?: string;
  external?: boolean;
}>();
</script>

<template>
  <MenuItem class="dropdown-menu-item" as="div">
    <BaseIcon v-if="icon" :name="icon" class="icon" />
    <span class="label">
      <slot></slot>
    </span>
    <BaseIcon v-if="external" name="open_in_new" class="external" />
  </MenuItem>
</template>

<style lang="scss" scoped>
.dropdown-menu-item {
  display: flex;
  align-items: center;
  gap: 0.4em;
  border-radius: calc(var(--main-border-radius) - 3px);
  font-size: 0.8em;
  text-decoration: none;
  cursor: pointer;
  padding: 0.5rem 0.5rem;

  .icon {
    font-size: 1.1em;
  }

  .external {
    font-size: 1em;
    margin-left: auto;
    opacity: 0;
  }

  &:hover {
    background-color: var(--menu-body-text-color);
    color: var(--menu-body-background-color);

    .external {
      opacity: 1;
    }
  }

  &:focus {
    background-color: var(--menu-text-background-color);
    color: var(--menu-body-background-color);
  }
}
</style>
